var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarOlivier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-23,.cls-24{fill:none;}.cls-2{opacity:0.32;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#bfdbf7;}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_161);}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_26);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_13);}.cls-8,.cls-9{opacity:0.45;}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_78);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_78-2);}.cls-10{fill:#212433;}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_163);}.cls-12{fill:#1a1a1a;}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_87);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_87-2);}.cls-15{clip-path:url(#clip-path-2);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_132);}.cls-17{opacity:0.71;fill:url(#D\xE9grad\xE9_sans_nom_144);}.cls-18{fill:#2d3047;}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_78-3);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_115);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_123);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_116);}.cls-23,.cls-24{stroke:gray;stroke-width:0.818px;}.cls-23{stroke-miterlimit:10;}.cls-24{stroke-linecap:round;stroke-linejoin:round;}.cls-25{opacity:0.79;fill:url(#D\xE9grad\xE9_sans_nom_111);}.cls-26{fill:#585123;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100,
    cy: 100,
    r: 100
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_161",
    x1: 112.30884,
    y1: 215.57103,
    x2: 93.69835,
    y2: 110.0257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14767,
    stopColor: "#ff9a5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36898,
    stopColor: "#ffa471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63647,
    stopColor: "#ffb692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93766,
    stopColor: "#ffcec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd3cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_26",
    x1: 83.39709,
    y1: 88.83506,
    x2: 71.54946,
    y2: 109.35577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17479,
    stopColor: "#ff9b78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43665,
    stopColor: "#ffa98d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#ffbfae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98166,
    stopColor: "#ffd3cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13",
    x1: 98.37286,
    y1: 42.70125,
    x2: 113.65939,
    y2: 129.39547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb38b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19401,
    stopColor: "#ffb792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48456,
    stopColor: "#ffc1a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83412,
    stopColor: "#ffd2c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86108,
    stopColor: "#ffd3cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_78",
    x1: 424.68546,
    y1: 86.87826,
    x2: 438.95543,
    y2: 86.87826,
    gradientTransform: "matrix(0.97898, 0.20393, -0.20393, 0.97898, -321.57036, -81.68494)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67666,
    stopColor: "#f89a77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f29d7c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_78-2",
    x1: 865.42448,
    y1: -7.43881,
    x2: 879.69445,
    y2: -7.43881,
    gradientTransform: "matrix(-0.97898, 0.20393, 0.20393, 0.97898, 974.15779, -81.68494)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_163",
    x1: 145.52367,
    y1: 91.05694,
    x2: 128.3717,
    y2: 97.29975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12339,
    stopColor: "#fe9b78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30823,
    stopColor: "#fcaa8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53054,
    stopColor: "#f9c2ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61674,
    stopColor: "#f7cdbd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_87",
    x1: 77.42501,
    y1: 67.48804,
    x2: 94.34275,
    y2: 67.48804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00039,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#43414a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86032,
    stopColor: "#4e4a59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_87-2",
    x1: 446.71016,
    y1: 301.1384,
    x2: 463.6279,
    y2: 301.1384,
    gradientTransform: "matrix(-1.18259, 0.00607, 0.00454, 0.88528, 655.09732, -201.92556)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_87"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.68507,46.42127a22.41766,22.41766,0,0,0-8.998,11.45194,20.25476,20.25476,0,0,0-.818,7.362c.65454,16.28114-1.11885,15.13912,0,26.58487a165.45346,165.45346,0,0,0,6.544,31.49284c.0004-.0007,8.07032,5.709,15.95092,7.362,7.07878,1.48481,13.01863-.51045,17.58691-2.045,5.5675-1.87025,12.74544-4.2814,15.95092-10.634.40121-.79523.82079-1.81183,1.227-11.45194,0,0,.7522-17.85252-.409-28.62986-.02407-.22307-.18743-1.72646-.409-3.681-.43286-3.81788-.74431-6.32679-.818-6.953-.97916-8.32494,1.48861-11.97287-.409-15.54192-1.049-1.97289-3.17372-3.43614-15.13292-5.317C99.76465,43.87562,91.55174,42.67908,85.68507,46.42127Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_132",
    x1: 111.97734,
    y1: 132.23403,
    x2: 105.15724,
    y2: 93.55535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35596,
    stopColor: "#424048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42767,
    stopColor: "#49454c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53236,
    stopColor: "#5d5457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65723,
    stopColor: "#7d6b6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79766,
    stopColor: "#a98c83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94933,
    stopColor: "#e1b6a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6c5af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_144",
    x1: 102.2957,
    y1: 105.25278,
    x2: 100.89895,
    y2: 97.33141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03253,
    stopColor: "#f6c5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21275,
    stopColor: "#d0a999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6128,
    stopColor: "#716362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80062,
    stopColor: "#424047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_78-3",
    x1: 100.41181,
    y1: 99.59239,
    x2: 100.41181,
    y2: 95.72875,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_115",
    x1: 103.05562,
    y1: 111.86652,
    x2: 101.94244,
    y2: 105.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00236,
    stopColor: "#f19b7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45034,
    stopColor: "#f1ab8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8607,
    stopColor: "#f1b69e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_123",
    x1: 101.95592,
    y1: -3238.04183,
    x2: 102.79486,
    y2: -3242.79968,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -3134.52702)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.56615,
    stopColor: "#f1b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77357,
    stopColor: "#f1ab8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f19b7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_116",
    x1: 88.22673,
    y1: 105.41976,
    x2: 116.25874,
    y2: 105.41976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00039,
    stopColor: "#543834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45845,
    stopColor: "#50434a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86032,
    stopColor: "#4e4a59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_111",
    x1: 115.53412,
    y1: 102.03651,
    x2: 117.43184,
    y2: 102.03651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e4a59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04966,
    stopColor: "#484757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20471,
    stopColor: "#394053"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MinDef_ILLU_vectorisation_v3 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_42",
    "data-name": "Calque 42"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.90593,110.634c-18.019-.73682-26.95512-1.05185-29.85685,2.863-2.81136,3.79292.69757,7.10654,2.045,20.8589,1.078,11.0028,2.14684,21.91174-3.681,27.40286-5.68174,5.35342-12.29131.25513-21.67689,4.908-8.96221,4.443-16.63482,15.883-15.13293,24.13088,3.52052,19.33324,60.70345,36.09766,98.56851,15.13292,13.24311-7.33231,26.37887-20.52628,23.72188-28.22086-3.054-8.84438-24.36424-2.86638-34.35583-17.17791-6.48605-9.29033-6.18939-24.24731-6.135-26.99387.19691-9.92848,2.98681-15.93894-.818-20.0409C124.76714,111.53722,122.34,110.97884,113.90593,110.634Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.91411,87.73006c-.60331-.984-2.75415-4.49249-4.09-4.09-1.0193.30715-.95959,2.70931-1.227,7.362-.58993,10.263-1.55641,10.33449-.818,13.08794,1.47173,5.48752,6.80119,10.76156,9.40695,9.816C85.02045,112.51438,83.80933,97.346,77.91411,87.73006Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.68507,46.01227a22.41771,22.41771,0,0,0-8.998,11.45194,20.2548,20.2548,0,0,0-.818,7.362c.65454,16.28113-1.11885,15.13911,0,26.58486a165.45389,165.45389,0,0,0,6.544,31.49285c.0004-.0007,8.07032,5.709,15.95092,7.362,7.07878,1.48481,13.01863-.51045,17.58691-2.045,5.5675-1.87025,12.74544-4.2814,15.95092-10.63395.40121-.79523.82079-1.81183,1.227-11.45194,0,0,.7522-17.85252-.409-28.62986-.02407-.22307-.18743-1.72646-.409-3.681-.43286-3.81788-.74431-6.32679-.818-6.953-.97916-8.325,1.48861-11.97288-.409-15.54193-1.049-1.97289-3.17372-3.43614-15.13292-5.317C99.76465,43.46662,91.55174,42.27008,85.68507,46.01227Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M90.6265,90.815c-.829-3.97053-10.51255-6.495-12.96073-4.371-2.3589,2.04659.55723,9.66,5.55078,10.34739C87.00592,97.31306,91.23772,93.74244,90.6265,90.815Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.24975,88.361c.829-3.97053,10.51255-6.495,12.96073-4.371,2.3589,2.0466-.55723,9.66-5.55078,10.34739C114.87033,94.85908,110.63853,91.28846,111.24975,88.361Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M86.91207,44.37628c-1.55242-3.29605,3.1899-8.94963,6.953-11.86094a21.74821,21.74821,0,0,1,4.908-2.863c10.17682-4.2779,25.34179-5.40774,26.58486-1.636.906,2.749-6.16143,6.34656-4.908,9.407.98305,2.40017,5.90141,1.58247,7.362,4.908a4.3258,4.3258,0,0,1,0,3.681c-1.72107,2.95395-7.6742.18253-18.8139.818-5.85559.334-8.9043,1.36758-15.13293.409C88.00566,46.33749,87.14722,44.87554,86.91207,44.37628Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M133.53783,87.32106c.84346-4.59883,1.408-7.6772,3.272-8.18,2.05976-.55558,4.91177,2.25109,6.135,4.908a10.83849,10.83849,0,0,1,.818,3.681c1.16019,9.96244,1.38736,9.43342,1.227,10.63395-.2056,1.53893-1.15371,6.51351-5.317,9.407-.49457.3437-4.47461,3.04881-6.544,1.636-1.37327-.93762-.85334-2.97082-.409-11.04294C133.06323,92.12609,132.88959,90.85566,133.53783,87.32106Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Yeux"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M118.81391,79.1411c.41229-1.34152-1.79087-3.78762-4.09-3.681-1.39655.06481-3.06709,1.08251-3.09934,2.34126-.03495,1.36479,1.87394,2.3079,3.09934,2.56672C116.315,80.7042,118.47321,80.25,118.81391,79.1411Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M93.456,61.96319a4.23086,4.23086,0,0,1,.818,3.272,3.732,3.732,0,0,1-.818,1.636c-2.33456,2.8532-14.5393,9.24139-15.95092,6.953-.23435-.37984.04763-.64385.818-3.272.97207-3.31632.83157-3.94859,1.227-4.908C81.41616,61.11694,91.15,59.1686,93.456,61.96319Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M109.20659,62.5838a3.09974,3.09974,0,0,0-.95248,2.90159,3.1353,3.1353,0,0,0,.97479,1.44334c2.7738,2.51171,17.23605,8.093,18.895,6.0585.27542-.33769-.05925-.5697-.98222-2.89166-1.16463-2.93-1.00136-3.49055-1.47334-4.33748C123.441,61.76155,111.921,60.09582,109.20659,62.5838Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M77.91411,102.863c.90986-.29986,3.52062,3.71692,6.953,8.998,2.93757,4.51975,3.88518,6.56514,6.135,6.953,2.02393.34888,4.69949-.71285,5.317-2.454.05552-.15657.50875-.54061,0-1.636-.42388-.91256-1.28581-1.26055-1.227-2.045a1.17993,1.17993,0,0,1,.409-.818c1.06983-.80481,3.01986,2.19427,5.726,2.045,2.27066-.12522,3.46261-2.3783,5.726-2.045.56067.08258.7447.25872.818.409.33641.68948-1.27352,1.61792-1.227,2.863a1.93039,1.93039,0,0,0,.14419.51035c.62707,1.413,3.57324,2.06766,5.99078,1.53464a11.56155,11.56155,0,0,0,4.908-2.863,9.71281,9.71281,0,0,0,1.28022-1.18865c1.515-1.74663,2.243-4.22518,4.85475-10.67229,4.66064-11.50487,6.40208-13.63473,7.771-13.49693a1.8424,1.8424,0,0,1,1.227.818c2.48584,3.06649,6.99021,16.80377,0,28.62986-6.40737,10.83994-19.76571,15.49519-31.08385,14.31493a35.18418,35.18418,0,0,1-20.85889-10.225C77.1032,106.80149,77.12467,103.1232,77.91411,102.863Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M85.68507,108.18c-.59922.03944-1.14082-1.759-1.227-2.045-.248-.82359-.707-2.34725,0-3.272.51284-.67082,1.181-.42718,2.863-.818,1.62711-.37814,3.1297-1.20642,6.135-2.863a6.66576,6.66576,0,0,1,1.636-.818c1.80515-.44525,2.40926.7493,4.499.818a11.83736,11.83736,0,0,0,4.908-1.227,6.47215,6.47215,0,0,1,2.454-.818c2.11057-.09185.95906.24954,2.863.818,3.03743.90707,5.16849-2.83493,7.362-2.045,2.186.78724,2.66918,5.43989,2.045,5.726-.43865.20111-1.0175-1.94134-2.863-2.454-2.16931-.60261-3.27828,1.82741-6.953,2.863-1.90759.53761-1.858-.047-7.771,0a55.07178,55.07178,0,0,0-6.953.409c-3.929.53291-6.56394.92643-7.771,2.863C86.09956,106.62055,86.23277,108.14391,85.68507,108.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M133.53783,93.047c.29936-.01078.60861-2.46117,1.227-7.362.16176-1.28231-.08658-2.63891.818-3.681.80851-.93143,1.80954-.92424,2.454-1.227,2.70462-1.27063,1.45386-9.15982,0-19.63191-.44085-3.17572-1.9716-14.30324-4.908-18.4049-.22067-.30825-.96018-1.2905-2.045-2.863-1.97059-2.85649-2.15313-3.41737-2.863-4.09-1.99736-1.89261-5.05636-1.72-6.544-1.636-9.13076.51524-13.52,9.65639-17.17791,8.18-4.20871-1.6988-1.25246-14.38233-5.726-15.95092-1.18176-.41439-1.77469.3351-6.135,2.454-8.6951,4.22538-11.882,3.9397-13.90593,7.362-.83238,1.40753-.91016,2.49882-1.227,5.317-1.314,11.6863-2.24519,10.47259-2.454,17.17792-.45832,14.72223,1.05086,27.43062,1.636,27.40286.574-.02726,2.41-12.40993,1.636-24.13088a17.67535,17.67535,0,0,1,1.227-8.18c.53022-1.26274,2.86279-6.35524,6.953-6.953,1.43938-.21039,2.35493.23585,4.09.818a49.12771,49.12771,0,0,0,17.17791,2.045c4.49788-.33371,4.57686-1.25715,7.362-.818a56.76633,56.76633,0,0,1,8.18,1.636,11.323,11.323,0,0,1,3.272,1.227,8.51958,8.51958,0,0,1,2.863,3.681,14.94439,14.94439,0,0,1,1.227,6.953c-.02,1.88083-.25323,2.00684-.409,4.09-.25043,3.35017.1373,5.9091.818,10.22495.57706,3.65851.71575,3.3251,1.227,6.544C133.26244,89.22226,133.206,93.059,133.53783,93.047Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M106.953,95.91c-.22008-.54689-2.23082.30855-6.953.409-4.19313.08917-5.96033-.51395-6.135,0-.251.73881,2.93887,3.34218,6.544,3.272C104.10985,99.51891,107.25023,96.64863,106.953,95.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M89.36605,107.771a24.82846,24.82846,0,0,0,7.771,3.272,17.56352,17.56352,0,0,0,8.18.409c5.33934-1.21291,8.40932-5.4335,9.407-6.953a19.03872,19.03872,0,0,1-4.499,2.454,22.06912,22.06912,0,0,1-8.18,1.227C98.76522,108.22489,94.47014,108.16368,89.36605,107.771Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M90.59305,108.18c2.52109-2.95695,4.62469-3.64623,6.135-3.681,1.38885-.032,1.96351.49677,4.09.409,2.18278-.09017,2.30081-.67711,4.499-.818,1.79177-.11483,2.23252.24184,4.908.409a32.64772,32.64772,0,0,0,4.09,0,18.3529,18.3529,0,0,1-4.908,2.454c-2.94756.9489-5.122.79473-8.99795.818C98.14184,107.78454,94.77919,107.862,90.59305,108.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M115.74634,102.24935a15.90007,15.90007,0,0,1-2.08887,3.08545,6.08468,6.08468,0,0,1-5.13818,2.38037c-.6145.01367-1.21607.0332-1.8125.07764a28.06438,28.06438,0,0,0-3.59107.55566,12.79552,12.79552,0,0,1-3.83227-.00391,14.38222,14.38222,0,0,0-1.761-.22461,10.85607,10.85607,0,0,0-1.74707.09229,33.312,33.312,0,0,1-3.70312.37793,5.89084,5.89084,0,0,1-3.52417-1.228,6.15644,6.15644,0,0,0,3.49.62744c1.17822-.15966,2.36743-.47949,3.58081-.72216a10.18837,10.18837,0,0,1,3.82177-.07374,12.08946,12.08946,0,0,0,3.51-.06054,26.04534,26.04534,0,0,1,3.696-.49707c.63037-.01758,1.25757-.00781,1.87134.00683a7.4368,7.4368,0,0,0,1.71606-.0708,6.95757,6.95757,0,0,0,3.0044-1.66406A20.96378,20.96378,0,0,0,115.74634,102.24935Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lunettes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M96.93252,76.48262c2.142,6.23682-6.71182,16.333-13.49694,14.72392-5.49561-1.30318-9.87916-10.34347-6.544-15.95092,2.84551-4.784,9.794-4.52154,10.22494-4.499C90.72905,70.94547,95.66688,72.79744,96.93252,76.48262Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M104.052,75.8145c-1.80894,6.34157,7.567,15.95482,14.25741,13.98881,5.41892-1.59226,9.31778-10.85193,5.69042-16.27494-3.09484-4.62669-10.01965-3.99672-10.44882-3.95139C109.95365,69.95672,105.12076,72.06752,104.052,75.8145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M97.137,78.73211a5.63921,5.63921,0,0,1,3.272-1.227,7.14665,7.14665,0,0,1,3.58431.98764"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "125.358 75.869 128.63 75.869 133.129 80.368"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "75.46 78.732 73.415 78.732 75.46 84.049"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M115.54371,100.41288c.09046-.10494.78809.1927,1.25682.7541a2.687,2.687,0,0,1,.50273,2.51364c-.1058.01878-.14765-.693-.75409-1.75955C116.00152,100.95808,115.4546,100.51635,115.54371,100.41288Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M83.44153,79.56151c-.364-1.35044,1.585-3.73321,3.61791-3.56483,1.2348.10231,2.71148,1.16345,2.73956,2.421.03037,1.3635-1.65787,2.25367-2.74148,2.479C85.65047,81.18939,83.74233,80.67767,83.44153,79.56151Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M128.62986,130.26585a.455.455,0,0,0,0-.409c-.52253-.68549-5.02241,2.06766-7.362,3.272a33.17817,33.17817,0,0,1-15.95092,3.272c-8.37876-.108-17.22235-3.34867-18.4049-4.09a5.07112,5.07112,0,0,0-2.454-.818c-.19452-.009-.34889-.00289-.409,0,.83517,1.91868,5.03129,13.18629,0,23.72188a17.03328,17.03328,0,0,1-6.953,7.362c-5.59306,3.08-10.41327,1.19494-17.17791.818-10.47947-.58394-24.21,2.57122-31.49284,11.043-4.90908,5.71049-5.68983,12.44208-6.135,16.76891-2.334,22.68591,14.62777,40.77079,15.54192,41.7178,37.92068,39.28607,121.04183-6.1853,122.69939-7.771.77386-.74031,1.72007-1.677,1.72007-1.677,2.95535-3.67079,7.4726-9.07744,13.36023-15.33612,7.93771-8.43808,10.19459-9.73817,11.50456-13.66169,2.77951-8.32525-1.4227-20.32029-9.40695-26.58487-13.76793-10.8026-30.7077,1.7695-42.12679-7.771C131.09752,156.37532,126.67284,148.55533,128.62986,130.26585Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarOlivier);
export default __webpack_public_path__ + "static/media/avatar_olivier.169b9bc07b7984b5afec13b533ba0ffd.svg";
export { ForwardRef as ReactComponent };